// RBAC permission ids (DimPermission.PermissionId). Access checks use ids, never names.
// Keep in sync with the backend PERMISSION_* settings.
export const MANAGE_USERS_PERMISSION_ID = 16
export const SEMANTICMODELS_MANAGE_PERMISSION_ID = 34
export const ANALYTICS_QUERY_PERMISSION_ID = 35

export const hasPermission = (
  permissionIds: number[] | undefined,
  permissionId: number,
): boolean => (permissionIds || []).includes(permissionId)
